export const ACCOUNT_PATHS = {
  details: 'account'
};
